import script from "./IniFileEtcSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./IniFileEtcSetting.vue?vue&type=script&setup=true&lang=ts"

import "./IniFileEtcSetting.vue?vue&type=style&index=0&id=580946b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580946b9"]])

export default __exports__